function LoadArticleListWidget(area) {
    var container = jQuery('#' + area);

    // Lösning: Hämta attributen direkt med `.attr()` istället för `.data()`
    var type = container.attr('data-type');
    var term = container.attr('data-term');

    jQuery.get(jjAdManager.Config.GetServiceUrl() + "articlewidgets/list?type=" + type + "&term=" + term, function (data) {
        jQuery.get("/wp-content/themes/jaktojagare.se/templates/widget_articlelist.html", function (template) {
            container.html(Mustache.render(template, data));
        });
    });
}

function ToggleQA(id){
    var query = id + ' .questions__content.accordion__content';
    jQuery(query).toggle('slow');
}

jQuery(function() {
    if(window.location.hash) {
        ToggleQA(window.location.hash);
    }
});

function ShareWindow(url, identifier, width, height){
    var winLeft=(screen.availWidth-width)/2;
    var winTop=(screen.availHeight-height)/2;

    window.open(url, identifier, 'width=' + width + ', height=' + height + ', left=' + winLeft + ', top=' + winTop);
}